import { render, staticRenderFns } from "./Hotboom.vue?vue&type=template&id=5f195df2&scoped=true&"
import script from "./Hotboom.vue?vue&type=script&lang=js&"
export * from "./Hotboom.vue?vue&type=script&lang=js&"
import style0 from "./Hotboom.vue?vue&type=style&index=0&id=5f195df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f195df2",
  null
  
)

export default component.exports